export const getAppBaseUrl = (isDemo?: boolean): string => {
	const protocol = window.location.protocol
	const hostname = window.location.hostname
	const port = window.location.port

	if (isDemo) {
		const aiServicePort = 3000
		return `${protocol}//${hostname}:${aiServicePort}`
	}

	return `${protocol}//${hostname}${port ? `:${port}` : ''}`
}
